import WebSocket from './WebSocket';

export default WebSocket;
